import React, { Fragment } from 'react'
import { Locale } from 'locale'
import { RouteConfig } from 'view/routes'
import { LeftNavigationPanel } from './LeftNavigationPanel'
import { LeftNavigationGradientOverlay } from './LeftNavigationGradientOverlay'
import { LeftNavigationTile } from './LeftNavigationTile'
import { LeftNavigationTileLink } from './LeftNavigationTileLink'
import { LeftNavigationDefaultRouteRenderer } from './LeftNavigationDefaultRouteRenderer'

interface LeftNavigationProps {
  isLeftNavigationMinimised: boolean
  routes: RouteConfig[]
}

export const LeftNavigation: React.FunctionComponent<LeftNavigationProps> = props => {
  const { routes, isLeftNavigationMinimised } = props

  const renderLinkForMinimisedNavigation = (routeConfig: RouteConfig) => {
    return (
      <LeftNavigationTile key={routeConfig.url} nestingLevel={0}>
        <LeftNavigationTileLink
          url={routeConfig.url}
          label={Locale.translate(routeConfig.caption)}
          numberOfItems={null}
          showActivityHighlight={null}
          showAlertHighlight={null}
          showWarnHighlight={null}
          icon={routeConfig.icon}
          isLeftNavigationMinimised={true}
          isSecondary={false}
        />
      </LeftNavigationTile>
    )
  }

  const renderLinkForMaximisedNavigation = (routeConfig: RouteConfig) => {
    return routeConfig.renderer ? routeConfig.renderer(routeConfig) : <LeftNavigationDefaultRouteRenderer route={routeConfig} />
  }

  return (
    <LeftNavigationPanel aria-label="Navigation Panel" isMinimised={isLeftNavigationMinimised}>
      {routes.map(route => (
        <Fragment key={route.url}>
          {isLeftNavigationMinimised ? renderLinkForMinimisedNavigation(route) : renderLinkForMaximisedNavigation(route)}
        </Fragment>
      ))}
      <LeftNavigationGradientOverlay />
    </LeftNavigationPanel>
  )
}
